/**
 * QuickstartNotFound Component
 *
 * Displayed when a campaign URL slug cannot be resolved to a valid campaign.
 * This is shown before any theme is loaded, so it uses generic styling.
 */

export const QuickstartNotFound = () => {
  return (
    <div className='flex h-screen w-screen flex-col items-center justify-center bg-black text-white'>
      <div className='flex flex-col items-center space-y-6 px-8 text-center'>
        {/* Logo */}
        <a href='https://playcast.io' rel='noopener noreferrer'>
          <img src='/icon.png' alt='Logo' className='h-16 w-16' />
        </a>
        <h1 className='text-6xl font-bold'>404</h1>
        <h2 className='text-2xl font-semibold'>Game Not Found</h2>
        <p className='max-w-md text-gray-400'>The game you're looking for doesn't exist or is no longer available.</p>
      </div>
    </div>
  );
};

